// extracted by mini-css-extract-plugin
export var header = "_tn-1";
export var maskBottom = "_tn-6";
export var maskMiddle = "_tn-7";
export var maskTop = "_tn-5";
export var root = "_tn-0";
export var scrollDownButton = "_tn-3";
export var scrollDownButtonHidden = "_tn-4";
export var viewport = "_tn-2";